<template>
	<v-dialog :model-value="dialog.open" width="600" persistent>
		<v-card color="white">
			<v-card-title class="text-h1 font-weight-bold">
				Show Audio
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" @click="close" variant="plain"></v-btn>
			</v-card-title>
			<v-card-text class="text-body-2">
				<v-row class="align-center pb-4">
					<label class="text-caption pa-2">Primary Feed</label>
					<v-tooltip location="top" :disabled="!primaryErrorTooltip"
						text="Audio format not supported or source not found.">
						<template v-slot:activator="{ props }">
							<audio v-bind="props" controls controlslist="nodownload noplaybackrate" :src="primaryFeed"
								id="primary"></audio>
						</template>
					</v-tooltip>
					<v-btn icon variant="text" density="compact" color="#717277" class="ml-3"
						@click="copyToClipboard(primaryFeed)">
						<v-icon icon="mdi-content-copy" size="18"/>
					</v-btn>
				</v-row>
				<v-row class="align-center pb-4">
					<label class="text-caption pa-2">Failover Feed</label>
					<v-tooltip location="top" :disabled="!failoverErrorTooltip"
						text="Audio format not supported or source not found.">
						<template v-slot:activator="{ props }">
							<audio v-bind="props" controls controlslist="nodownload noplaybackrate" :src="failoverFeed"
								id="failover"></audio>
						</template>
					</v-tooltip>
					<v-btn icon variant="text" density="compact" color="#717277" class="ml-3"
						@click="copyToClipboard(failoverFeed)">
						<v-icon icon="mdi-content-copy" size="18"/>
					</v-btn>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="primary" @click="close">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>

export default {
	name: "ShowAudioFeedsDialog",

	props: ["dialog", "options"],

	emits: ["close"],

	data() {
		return {
			show: this.options.show,
			primaryErrorTooltip: false,
			failoverErrorTooltip: false
		}
	},

	computed: {
		primaryFeed() {
			return `https://navale-e2.soundplus.iheartmedia.com/${this.show.settings?.feed}A-mp4`;
		},

		failoverFeed() {
			return `https://navale-w2.soundplus.iheartmedia.com/${this.show.settings?.feed}B-mp4`;
		},

		activeStudioAuditionOutputDevice() {
			return this.$store.getters.getActiveStudioAuditionOutputDevice();
		}
	},

	methods: {
		setOutputDevice() {
			document.getElementById("primary").setSinkId(this.activeStudioAuditionOutputDevice?.device ?? "default");
			document.getElementById("failover").setSinkId(this.activeStudioAuditionOutputDevice?.device ?? "default");
		},

		handleAudioSourceError(event) {
			const source = event.target.id;
			document.getElementById(source).classList.add("error");
			this[`${source}ErrorTooltip`] = true;
		},

		copyToClipboard(textToCopy) {
			navigator.clipboard.writeText(textToCopy);
			this.$store.commit("SHOW_SUCCESS_NOTIFICATION", {message: `Copied!`});
		},

		close() {
			this.$emit("close");
		}
	},

	mounted() {
		this.setOutputDevice();

		document.getElementById("primary")?.addEventListener("error", this.handleAudioSourceError);
		document.getElementById("failover")?.addEventListener("error", this.handleAudioSourceError);
	},

	beforeUnmount() {
		document.getElementById("primary").removeEventListener("error", this.handleAudioSourceError);
		document.getElementById("failover").removeEventListener("error", this.handleAudioSourceError);
	}
};
</script>

<style lang="scss" scoped>
audio {
	height: 40px;
	width: 90%;
	border-radius: 20px;

	&.error {
		&::-webkit-media-controls-panel {
			background-color: rgb(239, 154, 154);
		}
	}
}
</style>